import * as types from './mutation-types'

export default {
  [types.SET_USER] (state, storeUser = {}) {
    state.storeUser = storeUser
    sessionStorage.setItem('storeUser', JSON.stringify(storeUser))
  },
  [types.SET_MCH] (state, storeMch = {}) {
    state.storeMch = storeMch
    sessionStorage.setItem('storeMch', JSON.stringify(storeMch))
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js